import type { IClipBoardReadData, IClipBoardWriteData } from '@tencent/clipboard';
import { ICopyPasteInjectable } from '@src/slide/application/service/copy-paste/inject/copy-paste-injectable.interface';

export enum ClipboardDevice {
    TencentClipboard = 'TENCENT_CLIPBOARD',
    SlideLegacyClipboard = 'SLIDE_LEGACY_CLIPBOARD',
}

export type IClipboardDeviceDelegateInjectable = Pick<
    Partial<ICopyPasteInjectable>,
    'currentEnvIsInPrivate' | 'showClipboardProtection'
>;

// 写入剪切板传递的参数
export type AdapterClipboardWriteParams = Omit<IClipBoardWriteData, 'blob' | 'blobType'> & {
    syncClipboardItemConf?: Record<string, string>;
    asyncClipboardItemConf?: Record<string, Blob>;
};
export type SlideLegacyClipBoardWriteParams = {
    arr: { format: string; data: string }[];
};
export type MemoryClipboardWriteParams = {
    dataMap: unknown;
};

// 读取剪切板传递的参数
export type AdapterClipboardReadParams = {
    event?: ClipboardEvent;
    readFile?: boolean;
};
export type SlideLegacyClipBoardReadParams = {};
export type MemoryClipboardReadParams = {};

// 读取剪切板获得的结果
export type AdapterClipboardReadResult = IClipBoardReadData;
export type SlideLegacyClipboardReadResult = unknown;
export type MemoryClipboardReadResult = unknown;

// 写入剪切板参数汇总
export type WriteParamsMap = {
    adapter: AdapterClipboardWriteParams;
    legacy?: SlideLegacyClipBoardWriteParams;
    memory?: MemoryClipboardWriteParams;
};
// 读取剪切板参数汇总
export type ReadParamsMap = {
    adapter: AdapterClipboardReadParams;
    legacy?: SlideLegacyClipBoardReadParams;
    memory?: MemoryClipboardReadParams;
};

// 写入剪切板可选项
export type WriteOptions = {
    useMemoryClipboardExtra?: boolean;
    useMemoryClipboard?: boolean;
    clipboardDevice?: ClipboardDevice | undefined;
};
// 读取剪切板可选项
export type ReadOptions = {
    useMemoryClipboard?: boolean;
    clipboardDevice?: ClipboardDevice | undefined;
};

// 读取剪切板获得的结果汇总
export type ReadResult = AdapterClipboardReadResult | SlideLegacyClipboardReadResult | MemoryClipboardReadResult;

export interface IClipboardDeviceDelegate {
    /**
     * 默认C端走SlideLegacyClipboard, SaaS与私有化走TencentClipboard
     * */
    write(args?: { params?: WriteParamsMap; options?: WriteOptions }): Promise<void>;
    /**
     * 默认C端走SlideLegacyClipboard, SaaS与私有化走TencentClipboard
     * */
    read<T extends ReadResult>(args?: { params?: ReadParamsMap; options?: ReadOptions }): Promise<T | undefined>;
}
